module.exports = __webpack_public_path__ + "static/hero-illustration-6db238a11f59c07ba2a3974e60bee30c.svg";